import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig,
  withViewTransitions
} from '@angular/router';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { DropdownModule, SidebarModule } from '@coreui/angular';
import { IconSetService } from '@coreui/icons-angular';
import { routes } from './app.routes';
import { initializeKeycloak } from './app.server.module';
import { KeycloakService } from 'keycloak-angular';
import { AppInitService } from './app-init.service';
import { PLATFORM_ID } from '@angular/core';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { ToastrService, ToastNoAnimation, provideToastr, ToastrModule } from 'ngx-toastr';


export const appConfig: ApplicationConfig = {
  providers: [
  KeycloakService,
  AppInitService,
  provideToastr(),
  {
    provide: APP_INITIALIZER,
    useFactory: initializeKeycloak,
    multi: true,
    deps: [KeycloakService, PLATFORM_ID, AppInitService],
    
  },
  
      
    provideRouter(routes,
      withRouterConfig({
        onSameUrlNavigation: 'reload'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      }),
      withEnabledBlockingInitialNavigation(),
      withViewTransitions(),
    ),
    importProvidersFrom(SidebarModule, DropdownModule,HttpClientModule,AngularEditorModule,
      ToastrModule.forRoot({
        timeOut: 5000,
        positionClass: 'toast-top-right',
        preventDuplicates: true,
        enableHtml: true,
        onActivateTick: true
      }),
  
      BrowserAnimationsModule
    ),
    IconSetService,
    provideAnimations(),

  ]
};
